import React, { useCallback, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { IHeaderInput, setSearch, clear, setHeaderInputProps } from 'redux/globalSearch/slice';
import { useAppSelector } from './redux';

export const useGlobalSearch = (props?: Partial<IHeaderInput>) => {
  const searchText = useAppSelector((store) => store.globalSearch.search);
  const dispatch = useDispatch();
  const trottle = useRef<NodeJS.Timeout>(null);
  const { pathname } = useLocation();

  const onSearchChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | string) => {
      if (trottle.current) {
        clearTimeout(trottle.current);
        trottle.current = null;
      }
      trottle.current = setTimeout(() => {
        if (typeof event === 'string') {
          dispatch(setSearch(event?.trim()));
        } else {
          dispatch(setSearch(event.target.value?.trim()));
        }
        clearTimeout(trottle.current);
        trottle.current = null;
      }, 500);
    },
    [dispatch]
  );

  useEffect(() => {
    if (props) {
      dispatch(setHeaderInputProps(props));
    }
  }, [props, dispatch]);

  useEffect(() => {
    dispatch(clear());
  }, [pathname, dispatch]);

  return { searchText, onSearchChange };
};
